var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.36 2H2.64C2.286 2 2 2.286 2 2.64V17.36C2 17.714 2.286 18 2.64 18H17.36C17.714 18 18 17.714 18 17.36V2.64C18 2.286 17.714 2 17.36 2ZM7.12 14.64C7.12 14.728 7.048 14.8 6.96 14.8H5.36C5.272 14.8 5.2 14.728 5.2 14.64V5.36C5.2 5.272 5.272 5.2 5.36 5.2H6.96C7.048 5.2 7.12 5.272 7.12 5.36V14.64ZM10.96 9.04C10.96 9.128 10.888 9.2 10.8 9.2H9.2C9.112 9.2 9.04 9.128 9.04 9.04V5.36C9.04 5.272 9.112 5.2 9.2 5.2H10.8C10.888 5.2 10.96 5.272 10.96 5.36V9.04ZM14.8 10.48C14.8 10.568 14.728 10.64 14.64 10.64H13.04C12.952 10.64 12.88 10.568 12.88 10.48V5.36C12.88 5.272 12.952 5.2 13.04 5.2H14.64C14.728 5.2 14.8 5.272 14.8 5.36V10.48Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPage);
export default __webpack_public_path__ + "static/media/ProjectPage.1b57e5534c6f145c4809274acae2dee0.svg";
export { ForwardRef as ReactComponent };